import { render, staticRenderFns } from "./cantidad-lista-mini.vue?vue&type=template&id=0d8de7de&scoped=true&"
import script from "./cantidad-lista-mini.vue?vue&type=script&lang=ts&"
export * from "./cantidad-lista-mini.vue?vue&type=script&lang=ts&"
import style0 from "./cantidad-lista-mini.vue?vue&type=style&index=0&id=0d8de7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8de7de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCol,VIcon,VImg,VList,VListItemGroup,VProgressCircular,VRow})
